import React, { useContext } from 'react';
import { FormContext } from 'contexts/FormContext';
import { ArnContext } from 'contexts';
import {
  ApplicationName,
  FormNavigation,
  ControlInputGroup
} from 'components/CASAForm';
import {
  AuCallout,
  AuFormItemWrapper,
  AuDirectionLink
} from 'components/DTA';
import { MANUAL_POI_PRIMARY_DOCUMENTS_40POINTS, MANUAL_POI_PRIMARY_DOCUMENTS_70POINTS } from 'arnConstants';
import { ArnApplicationDvsMethodFormData } from 'types/forms/arnApplicationTypes';
import { useFormikContext } from 'formik';
import { getManualPOIPoints, getManualPOIPointsPrimary, getManualPOIPointsSecondary } from 'helpers/arnApplicationHelper';
import { IFormAlertType } from 'types/forms/formTypes';

const ManualPOIPrimary: React.FC = (props: any) => {
  const { setPreviousStep, previousStep } = useContext(ArnContext);
  const { values, validateForm } = useFormikContext<ArnApplicationDvsMethodFormData>();
  const { handleBack, setFormAlert, openStepById, setOnChangeValidation } = useContext(FormContext);
  const { nextStep } = props;
  const handleNext = async () => {
    if (values.manualPOIDocuments.primaryDocuments70Points
      && values.manualPOIDocuments.primaryDocuments70Points.length == 0
      && values.manualPOIDocuments.primaryDocuments40Points
      && values.manualPOIDocuments.primaryDocuments40Points.length == 0) {
      const alert: IFormAlertType = {
        as: 'error',
        title: 'You need to select at least one primary document',
        message:''
      };
      setFormAlert(alert);
      setOnChangeValidation(true);
      window.scrollTo(0, 0);
    }
    else {
      setFormAlert(null);
      setOnChangeValidation(false);
      if (getManualPOIPointsPrimary(values.manualPOIDocuments) >= 100 && getManualPOIPointsSecondary(values.manualPOIDocuments) == 0) {
        const nextStepsId = 'UploadFileForManualIdentification';
        const previousStepId = 'ManualPOIPrimary';
        setPreviousStep(previousStepId);
        openStepById(nextStepsId);
      }
      else {
        openStepById(nextStep);
      }
    }
  };

  return (
    <>
      <ApplicationName name='Manual verification' />
      <AuDirectionLink
        onClick={handleBack}
        text="Back"
        direction="left" />
      <AuFormItemWrapper>
        <h3>Select at least one primary document</h3>
        <p>You must provide at least one certified primary document. Foreign documents must also include an official translation.</p>
        <p>
          If you choose documentation that is worth less than 100 points, you will be asked for secondary documents to achieve 100 points of ID.
        </p>
      </AuFormItemWrapper>
      <ControlInputGroup
        name='manualPOIDocuments.primaryDocuments70Points'
        label='Primary documents (70 points)'
        type='checkbox'
        block={true}
        options={
          MANUAL_POI_PRIMARY_DOCUMENTS_70POINTS.map((e: string) => {
            return {
              label: e,
              value: e
            };
          })
        }
      />

      <ControlInputGroup
        name='manualPOIDocuments.primaryDocuments40Points'
        label='Primary documents (40 points)'
        type='checkbox'
        block={true}
        options={
          MANUAL_POI_PRIMARY_DOCUMENTS_40POINTS.map((e: string) => {
            return {
              label: e,
              value: e
            };
          })
        }
      />
      <AuFormItemWrapper>
        <AuCallout >
          <h4>{`You have ${getManualPOIPoints(values.manualPOIDocuments)} points of ID selected`}</h4>
          <p>You must provide at least one certified primary document.</p>
          <p>If you choose documentation that is worth less than 100 points, you will be asked for secondary documents to achieve 100 points of ID.</p>
        </AuCallout>
      </AuFormItemWrapper>
      <FormNavigation
        nextButtonText='Next'
        onNextAction={handleNext}
        hidePrevious
        showSaveAndExit={false} />
    </>
  );
};

export default ManualPOIPrimary;